/**
 * PRODUCT INFO TABS JAVASCRIPT
 * Prevents unwanted scroll behavior and height jumping when switching tabs
 */

function initProductInfoTabs(tabComponent) {
  // Override the scrollTo method to prevent page jumping
  const originalScrollTo = tabComponent.scrollTo.bind(tabComponent);

  tabComponent.scrollTo = function(options) {
    // Only allow scrolling if there's actual horizontal overflow
    if (this.scrollWidth > this.clientWidth) {
      originalScrollTo(options);
    }
    // Otherwise, do nothing to prevent page jump
  };

  // Watch for panel visibility changes to handle height transitions
  const panels = tabComponent.querySelectorAll('[slot="tabpanel"]');

  if (panels.length === 0) return;

  // Use MutationObserver to detect when panels change visibility
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
        handleHeightTransition(tabComponent);
      }
    });
  });

  // Observe each panel for hidden attribute changes
  panels.forEach(panel => {
    observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] });
  });

  // Store observer for cleanup if needed
  tabComponent._heightObserver = observer;
}

function handleHeightTransition(tabComponent) {
  // Capture current scroll position BEFORE any changes
  const scrollY = window.scrollY || window.pageYOffset;
  const scrollX = window.scrollX || window.pageXOffset;

  // Get current height FIRST before locking anything
  const currentHeight = tabComponent.offsetHeight;

  // Find and lock any safe-sticky elements to prevent them from jumping
  const stickyElements = document.querySelectorAll('safe-sticky');
  const stickyElementsArray = Array.from(stickyElements);

  stickyElementsArray.forEach(stickyEl => {
    const rect = stickyEl.getBoundingClientRect();
    const computedStyle = getComputedStyle(stickyEl);

    // Lock the element in its current visual position using fixed positioning
    // Capture all positioning details to maintain exact visual appearance
    stickyEl.style.position = 'fixed';
    stickyEl.style.top = rect.top + 'px';
    stickyEl.style.left = rect.left + 'px';
    stickyEl.style.width = rect.width + 'px';
    stickyEl.style.zIndex = computedStyle.zIndex;
  });

  // Create scroll lock function to prevent scroll position changes
  const lockScroll = () => {
    window.scrollTo(scrollX, scrollY);
  };

  // Prevent scroll during transition - using passive: false to allow scroll prevention
  window.addEventListener('scroll', lockScroll, { passive: false });

  // Lock the height temporarily
  tabComponent.style.minHeight = currentHeight + 'px';
  tabComponent.style.transition = 'min-height 0.25s ease-in-out';

  // Use requestAnimationFrame to ensure the style is applied
  requestAnimationFrame(() => {
    // Let the browser calculate the natural height with the new panel
    tabComponent.style.minHeight = 'auto';
    const newHeight = tabComponent.offsetHeight;

    // If heights are the same, no transition needed
    if (currentHeight === newHeight) {
      tabComponent.style.minHeight = '';
      tabComponent.style.transition = '';
      // Remove scroll lock if no transition needed
      window.removeEventListener('scroll', lockScroll);

      // Restore sticky elements by removing our temporary styles
      stickyElementsArray.forEach(stickyEl => {
        stickyEl.style.removeProperty('position');
        stickyEl.style.removeProperty('top');
        stickyEl.style.removeProperty('left');
        stickyEl.style.removeProperty('width');
        stickyEl.style.removeProperty('z-index');
      });
      return;
    }

    // Set to current height and transition to new height
    tabComponent.style.minHeight = currentHeight + 'px';

    requestAnimationFrame(() => {
      tabComponent.style.minHeight = newHeight + 'px';

      // Force scroll restoration at transition start
      window.scrollTo(scrollX, scrollY);

      // Clean up after transition
      setTimeout(() => {
        tabComponent.style.minHeight = '';
        tabComponent.style.transition = '';

        // Remove scroll lock and force final scroll position
        window.removeEventListener('scroll', lockScroll);
        window.scrollTo(scrollX, scrollY);

        // Restore sticky elements by removing our temporary styles
        stickyElementsArray.forEach(stickyEl => {
          stickyEl.style.removeProperty('position');
          stickyEl.style.removeProperty('top');
          stickyEl.style.removeProperty('left');
          stickyEl.style.removeProperty('width');
          stickyEl.style.removeProperty('z-index');
        });
      }, 250);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const productInfoTabs = document.querySelectorAll('.product-info-tabs');
  productInfoTabs.forEach(initProductInfoTabs);
});

// Handle dynamically added tabs (e.g., from Theme Editor)
document.addEventListener('shopify:section:load', (event) => {
  const productInfoTabs = event.target.querySelectorAll('.product-info-tabs');
  productInfoTabs.forEach(initProductInfoTabs);
});
